import { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import {
  menuGetir, dosyaUrl, siparisVer, bildirimGonder, masaSiparisleriGetir, musteriSiparisIptal,
  isletmeMasalariGetir, isletmeGarsonlariGetir, garsonGirisYap, isletmeGirisYap
} from '../services/api';
import { temaGetir } from '../temalar';
import { paraFormatla } from '../paraFormat';

// Sunucu hazır bir hata mesajı döndürmediyse (ör. istek sunucuya hiç ulaşmadı, yanıt yolda koptu,
// zaman aşımı vb.), kullanıcıya "İşlem yapılamadı" gibi belirsiz bir mesaj yerine NEDEN
// belirtilebiliyorsa onu göster — teşhis için önemli (kullanıcı talebi: 2026-07-26).
const hataMetniAl = (err, varsayilan) => {
  if (err.response?.data?.hata) return err.response.data.hata;
  if (err.response) return `Sunucu hatası (kod: ${err.response.status}). Lütfen tekrar deneyin.`;
  if (err.code === 'ECONNABORTED') return 'İstek zaman aşımına uğradı, lütfen tekrar deneyin.';
  return `Bağlantı hatası, lütfen tekrar deneyin. (${err.message || 'bilinmeyen'})`;
};

// Footer zemini temanın "koyu" rengi (temaya göre değişir) — üstündeki yazı bu zeminle daima
// kontrast oluştursun diye parlaklığa göre beyaz/siyah seçilir (koyu zeminde beyaz, açık zeminde siyah).
const kontrastMetinRengi = (hex) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  const parlaklik = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return parlaklik > 0.55 ? '#111111' : '#ffffff';
};

export default function IsletmeMenu() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const masaNo = searchParams.get('masa');
  // Admin'in Şablonlar > Önizle ekranından açılan, tasarımı gösteren ama sipariş/garson çağırma
  // gibi gerçek işlem tetiklemeyen mod. Kullanıcı talebi: 2026-07-26.
  const onizlemeModu = searchParams.get('onizleme') === '1';

  const [menu, setMenu] = useState(null);
  const [hata, setHata] = useState('');
  const [lisansBitti, setLisansBitti] = useState(false);
  const [aktifGrup, setAktifGrup] = useState(null);

  const [sepet, setSepet] = useState([]); // [{ urunId, ad, fiyat, adet }]
  const [sepetAcik, setSepetAcik] = useState(false);
  const [aciklama, setAciklama] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [onaySonuc, setOnaySonuc] = useState(null); // { tip: 'basari'|'hata', metin }

  const [bildirimGonderiliyor, setBildirimGonderiliyor] = useState(null); // hangi tip gönderiliyor
  const [bildirimMesaj, setBildirimMesaj] = useState(null); // { tip: 'basari'|'hata', metin }
  const [bildirimOnayPopup, setBildirimOnayPopup] = useState(null); // 'GARSON_CAGIR' | 'HESAP_ISTE' | null

  const [masaSiparisleri, setMasaSiparisleri] = useState([]);
  const [iptalPopup, setIptalPopup] = useState(null); // iptal edilmek istenen sipariş grubu
  const [iptalHata, setIptalHata] = useState('');

  // Ana giriş sayfası (masa parametresi olmadan /:slug açıldığında): Garson Paneli / Yönetim Paneli /
  // Menüyü Görüntüle seçimi. Kullanıcı talebi: 2026-07-27.
  const [masalarListesi, setMasalarListesi] = useState([]);
  const [garsonlarListesi, setGarsonlarListesi] = useState([]);
  const [hubAcikPanel, setHubAcikPanel] = useState(null); // null | 'GARSON' | 'MENU'

  const [hubSeciliMasa, setHubSeciliMasa] = useState('');

  const [hubSeciliGarson, setHubSeciliGarson] = useState('');
  const [hubGarsonSifre, setHubGarsonSifre] = useState('');
  const [hubGarsonGirisYukleniyor, setHubGarsonGirisYukleniyor] = useState(false);
  const [hubGarsonGirisHata, setHubGarsonGirisHata] = useState('');

  const [hubMudurKullaniciAdi, setHubMudurKullaniciAdi] = useState('');
  const [hubMudurSifre, setHubMudurSifre] = useState('');
  const [hubMudurGirisYukleniyor, setHubMudurGirisYukleniyor] = useState(false);
  const [hubMudurGirisHata, setHubMudurGirisHata] = useState('');

  const hubMenuyuGoruntule = () => {
    if (!hubSeciliMasa) return;
    navigate(`/${slug}?masa=${encodeURIComponent(hubSeciliMasa)}`);
  };

  const hubGarsonGirisiYap = (e) => {
    e.preventDefault();
    if (!hubSeciliGarson) { setHubGarsonGirisHata('Lütfen bir garson seçin.'); return; }
    setHubGarsonGirisHata(''); setHubGarsonGirisYukleniyor(true);
    garsonGirisYap(hubSeciliGarson, hubGarsonSifre, slug)
      .then((res) => {
        localStorage.setItem('isletmeId', res.data.id);
        localStorage.setItem('isletmeAd', res.data.ad);
        localStorage.setItem('isletmeSlug', res.data.slug);
        localStorage.setItem('isletmeRol', 'GARSON');
        localStorage.setItem('garsonId', res.data.garsonId);
        localStorage.setItem('garsonAdi', res.data.garsonAdi);
        navigate(`/${res.data.slug}/ayarlar/panel`);
      })
      .catch((err) => setHubGarsonGirisHata(err.response?.data?.hata || 'Giriş yapılamadı.'))
      .finally(() => setHubGarsonGirisYukleniyor(false));
  };

  const hubMudurGirisiYap = (e) => {
    e.preventDefault();
    setHubMudurGirisHata(''); setHubMudurGirisYukleniyor(true);
    isletmeGirisYap(hubMudurKullaniciAdi, hubMudurSifre)
      .then((res) => {
        localStorage.setItem('isletmeId', res.data.id);
        localStorage.setItem('isletmeAd', res.data.ad);
        localStorage.setItem('isletmeSlug', res.data.slug);
        localStorage.setItem('isletmeRol', 'MUDUR');
        navigate(`/${res.data.slug}/ayarlar/panel`);
      })
      .catch((err) => setHubMudurGirisHata(err.response?.data?.hata || 'Giriş yapılamadı.'))
      .finally(() => setHubMudurGirisYukleniyor(false));
  };

  const masaSiparisleriniYenile = () => {
    if (!masaNo) return;
    masaSiparisleriGetir(slug, masaNo).then((res) => setMasaSiparisleri(res.data)).catch(() => {});
  };

  const siparisiIptalEt = () => {
    if (onizlemeModu) { setIptalPopup(null); return; }
    setIptalHata('');
    musteriSiparisIptal(iptalPopup.id, slug, masaNo)
      .then(() => { setIptalPopup(null); masaSiparisleriniYenile(); })
      .catch((err) => {
        setIptalHata(hataMetniAl(err, 'İptal edilemedi.'));
        masaSiparisleriniYenile(); // durum değişmiş olabilir (garson önce davranmış) — güncel veriyi göster
      });
  };

  const bildirimGonderTikla = (tip) => {
    setBildirimOnayPopup(null);
    if (onizlemeModu) {
      setBildirimMesaj({ tip: 'basari', metin: 'Bu bir önizlemedir, gerçek bir bildirim gönderilmedi.' });
      return;
    }
    setBildirimGonderiliyor(tip);
    setBildirimMesaj(null);
    bildirimGonder(slug, masaNo, tip)
      .then(() => setBildirimMesaj({ tip: 'basari', metin: tip === 'GARSON_CAGIR' ? 'Garsonunuz bilgilendirildi.' : 'Hesap talebiniz iletildi.' }))
      .catch((err) => setBildirimMesaj({ tip: 'hata', metin: hataMetniAl(err, 'İşlem yapılamadı.') }))
      .finally(() => setBildirimGonderiliyor(null));
  };

  const sepeteEkle = (urun) => {
    setSepet((mevcut) => {
      const varOlan = mevcut.find((k) => k.urunId === urun.id);
      if (varOlan) {
        return mevcut.map((k) => k.urunId === urun.id ? { ...k, adet: k.adet + 1 } : k);
      }
      return [...mevcut, { urunId: urun.id, ad: urun.ad, fiyat: urun.fiyat, adet: 1 }];
    });
  };

  const adetDegistir = (urunId, delta) => {
    setSepet((mevcut) => mevcut
      .map((k) => k.urunId === urunId ? { ...k, adet: k.adet + delta } : k)
      .filter((k) => k.adet > 0));
  };

  const sepettenCikar = (urunId) => setSepet((mevcut) => mevcut.filter((k) => k.urunId !== urunId));

  const toplam = sepet.reduce((t, k) => t + k.fiyat * k.adet, 0);
  const toplamAdet = sepet.reduce((t, k) => t + k.adet, 0);

  const siparisiOnayla = () => {
    if (onizlemeModu) {
      setOnaySonuc({ tip: 'basari', metin: 'Bu bir önizlemedir, gerçek bir sipariş gönderilmedi.' });
      setSepet([]);
      setAciklama('');
      return;
    }
    setGonderiliyor(true);
    setOnaySonuc(null);
    siparisVer(slug, masaNo, aciklama, sepet.map((k) => ({ urunId: k.urunId, adet: k.adet })))
      .then(() => {
        setOnaySonuc({ tip: 'basari', metin: 'Siparişiniz alındı, teşekkürler!' });
        setSepet([]);
        setAciklama('');
        masaSiparisleriniYenile();
      })
      .catch((err) => setOnaySonuc({ tip: 'hata', metin: hataMetniAl(err, 'Sipariş verilemedi.') }))
      .finally(() => setGonderiliyor(false));
  };

  useEffect(() => {
    menuGetir(slug)
      .then((res) => {
        setMenu(res.data);
        if (res.data.gruplar.length > 0) setAktifGrup(res.data.gruplar[0].id);
      })
      .catch((err) => {
        setHata(err.response?.data?.hata || 'İşletme bulunamadı.');
        setLisansBitti(!!err.response?.data?.lisansBitti);
      });
  }, [slug]);

  // Ana giriş sayfası (masasız) için masa/garson listeleri — masalı görünümde de zararsız, kullanılmaz.
  useEffect(() => {
    if (masaNo) return;
    isletmeMasalariGetir(slug).then((res) => setMasalarListesi(res.data)).catch(() => {});
    isletmeGarsonlariGetir(slug).then((res) => setGarsonlarListesi(res.data)).catch(() => {});
  }, [slug, masaNo]);

  // Müşteri kendi masasındaki siparişlerin güncel durumunu görsün diye periyodik yenileniyor —
  // ekranını hiç yenilemeyen bir müşteri de bir süre sonra doğru durumu (ve iptal edilebilirliği) görür.
  useEffect(() => {
    if (!masaNo) return;
    masaSiparisleriniYenile();
    const zamanlayici = setInterval(masaSiparisleriniYenile, 15000);
    return () => clearInterval(zamanlayici);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, masaNo]);

  if (lisansBitti) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: 10, background: '#1e2a3a', color: '#fff', padding: 30, textAlign: 'center'
      }}>
        <div style={{ fontSize: 40 }}>⏳</div>
        <h2 style={{ margin: 0 }}>Lisans Süreniz Bitmiştir</h2>
        <p style={{ color: '#aab0b8', maxWidth: 320 }}>Bu menüye erişim geçici olarak durdurulmuştur. Lütfen hizmet sağlayıcınızla iletişime geçin.</p>
      </div>
    );
  }
  if (hata) return <div style={{ padding: 30, textAlign: 'center', color: '#8b1a1a' }}>{hata}</div>;
  if (!menu) return <div style={{ padding: 30, textAlign: 'center' }}>Yükleniyor...</div>;

  const tema = temaGetir(menu.tema);
  const footerMetinRengi = kontrastMetinRengi(tema.koyu);

  const footerIcerigi = (menu.adres || menu.telefon || menu.ekBilgi || menu.calismaSaatHaftaIci || menu.calismaSaatCumartesi || menu.calismaSaatPazar) && (
    <div style={{ background: tema.koyu, color: footerMetinRengi, padding: '20px 16px', marginTop: 10, textAlign: 'center' }}>
      <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 6 }}>{menu.ad}</div>
      {menu.adres && <div style={{ fontSize: 13, marginBottom: 3, opacity: 0.9 }}>{menu.adres}</div>}
      {menu.telefon && <div style={{ fontSize: 13, marginBottom: 3, opacity: 0.9 }}>{menu.telefon}</div>}
      {menu.ekBilgi && <div style={{ fontSize: 13, marginBottom: 3, opacity: 0.9 }}>{menu.ekBilgi}</div>}
      {(menu.calismaSaatHaftaIci || menu.calismaSaatCumartesi || menu.calismaSaatPazar) && (
        <div style={{ marginTop: 10, fontSize: 12, opacity: 0.85 }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Çalışma Saatleri</div>
          {menu.calismaSaatHaftaIci && <div>Hafta İçi: {menu.calismaSaatHaftaIci}</div>}
          {menu.calismaSaatCumartesi && <div>Cumartesi: {menu.calismaSaatCumartesi}</div>}
          {menu.calismaSaatPazar && <div>Pazar: {menu.calismaSaatPazar}</div>}
        </div>
      )}
    </div>
  );

  // Ana giriş sayfası — masa parametresi olmadan /:slug açıldığında (QR kod değil, doğrudan link/
  // yer imi ile gelindiğinde) müşteri/personel/müdür için 3 yönlendirme butonu gösterir.
  if (!masaNo) {
    return (
      <div style={{
        minHeight: '100vh',
        background: `radial-gradient(circle at top, ${tema.bgUst} 0%, ${tema.koyu} 55%, ${tema.bgAlt} 100%)`,
        display: 'flex', justifyContent: 'center'
      }}>
        <div style={{
          maxWidth: 480, width: '100%', minHeight: '100vh', position: 'relative',
          background: `radial-gradient(circle at 1px 1px, rgba(0,0,0,0.05) 1px, transparent 0) 0 0/24px 24px, ${tema.kartUst}`,
          boxShadow: '0 0 40px rgba(0,0,0,0.35)', display: 'flex', flexDirection: 'column'
        }}>
          <div style={{ position: 'relative', height: menu.bannerUrl ? 'auto' : 190, background: menu.bannerUrl ? 'transparent' : `linear-gradient(135deg, ${tema.koyu}, ${tema.bgUst})` }}>
            {menu.bannerUrl && <img src={dosyaUrl(menu.bannerUrl)} alt={menu.ad} style={{ display: 'block', width: '100%', height: 'auto' }} />}
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.15) 100%)' }} />
          </div>

          <div style={{ textAlign: 'center', padding: menu.logoUrl ? '0 16px 14px' : '16px 16px 14px' }}>
            {menu.logoUrl && (
              <img
                src={dosyaUrl(menu.logoUrl)}
                alt={menu.ad}
                style={{
                  width: 76, height: 76, borderRadius: '50%', objectFit: 'cover',
                  border: `4px solid ${tema.kartUst}`, boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
                  marginTop: -38, background: '#fff', position: 'relative', zIndex: 2
                }}
              />
            )}
            <h1 style={{ margin: '8px 0 0', fontSize: 22, fontWeight: 800, color: tema.koyu }}>{menu.ad}</h1>
          </div>

          <div style={{ flex: 1, padding: '10px 16px 24px', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <button
              onClick={() => setHubAcikPanel(hubAcikPanel === 'GARSON' ? null : 'GARSON')}
              style={{
                padding: '16px', borderRadius: 12, border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: 700,
                background: hubAcikPanel === 'GARSON' ? tema.accent : '#fff', color: hubAcikPanel === 'GARSON' ? '#fff' : tema.koyu,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)', textAlign: 'center'
              }}
            >
              👨‍🍳 Garson Paneli
            </button>
            {hubAcikPanel === 'GARSON' && (
              <form onSubmit={hubGarsonGirisiYap} style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: 10 }}>
                {hubGarsonGirisHata && <div style={{ fontSize: 12, fontWeight: 600, color: '#8b1a1a' }}>{hubGarsonGirisHata}</div>}
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Garson</label>
                  <select value={hubSeciliGarson} onChange={(e) => setHubSeciliGarson(e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }} required>
                    <option value="">Seçiniz</option>
                    {garsonlarListesi.map((g) => <option key={g.id} value={g.kullaniciAdi}>{g.kullaniciAdi}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
                  <input type="password" value={hubGarsonSifre} onChange={(e) => setHubGarsonSifre(e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <button type="submit" disabled={hubGarsonGirisYukleniyor} style={{ padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: tema.accent, color: '#fff', fontWeight: 700 }}>
                  {hubGarsonGirisYukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                </button>
              </form>
            )}

            <button
              onClick={() => setHubAcikPanel(hubAcikPanel === 'MUDUR' ? null : 'MUDUR')}
              style={{
                padding: '16px', borderRadius: 12, border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: 700,
                background: hubAcikPanel === 'MUDUR' ? tema.accent : '#fff', color: hubAcikPanel === 'MUDUR' ? '#fff' : tema.koyu,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)', textAlign: 'center'
              }}
            >
              🛠 Yönetim Paneli
            </button>
            {hubAcikPanel === 'MUDUR' && (
              <form onSubmit={hubMudurGirisiYap} style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: 10 }}>
                {hubMudurGirisHata && <div style={{ fontSize: 12, fontWeight: 600, color: '#8b1a1a' }}>{hubMudurGirisHata}</div>}
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Kullanıcı Adı</label>
                  <input value={hubMudurKullaniciAdi} onChange={(e) => setHubMudurKullaniciAdi(e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
                  <input type="password" value={hubMudurSifre} onChange={(e) => setHubMudurSifre(e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <button type="submit" disabled={hubMudurGirisYukleniyor} style={{ padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: tema.accent, color: '#fff', fontWeight: 700 }}>
                  {hubMudurGirisYukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                </button>
              </form>
            )}

            <button
              onClick={() => setHubAcikPanel(hubAcikPanel === 'MENU' ? null : 'MENU')}
              style={{
                padding: '16px', borderRadius: 12, border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: 700,
                background: hubAcikPanel === 'MENU' ? tema.accent : '#fff', color: hubAcikPanel === 'MENU' ? '#fff' : tema.koyu,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)', textAlign: 'center'
              }}
            >
              📋 Menüyü Görüntüle
            </button>
            {hubAcikPanel === 'MENU' && (
              <div style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Masa</label>
                  <select value={hubSeciliMasa} onChange={(e) => setHubSeciliMasa(e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }}>
                    <option value="">Seçiniz</option>
                    {masalarListesi.map((m) => <option key={m.id} value={m.ad}>{m.ad}</option>)}
                  </select>
                </div>
                <button onClick={hubMenuyuGoruntule} disabled={!hubSeciliMasa} style={{ padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: tema.accent, color: '#fff', fontWeight: 700 }}>
                  Menüyü Görüntüle
                </button>
              </div>
            )}
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '20px 10px' }}>
              <p style={{ margin: 0, fontSize: 17, color: tema.accent, fontWeight: 600, lineHeight: 1.6 }}>
                Burası sizin ana sayfanızdır.<br />Bu sayfayı sık kullanılanlarınıza ( yer imlerine ) ekleyerek daha hızlı erişebilirsiniz. Yönetici ve Garson girişlerini buradan yapacaksınız.
              </p>
            </div>
          </div>

          {footerIcerigi}
          <div style={{ textAlign: 'center', fontSize: 11, color: '#aab0b8', padding: '10px 0' }}>MenuPaylas ile hazırlanmıştır</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: `radial-gradient(circle at top, ${tema.bgUst} 0%, ${tema.koyu} 55%, ${tema.bgAlt} 100%)`,
      padding: '0',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <div style={{
        maxWidth: 480, width: '100%', minHeight: '100vh', position: 'relative',
        background: `
          radial-gradient(circle at 1px 1px, rgba(0,0,0,0.05) 1px, transparent 0) 0 0/24px 24px,
          ${tema.kartUst}
        `,
        boxShadow: '0 0 40px rgba(0,0,0,0.35)'
      }}>
        {/* Banner — genişliğe tam sığar, yükseklik görselin kendi en-boy oranına göre ayarlanır (kırpma yok) */}
        <div style={{
          position: 'relative',
          height: menu.bannerUrl ? 'auto' : 190,
          background: menu.bannerUrl ? 'transparent' : `linear-gradient(135deg, ${tema.koyu}, ${tema.bgUst})`
        }}>
          {menu.bannerUrl && (
            <img src={dosyaUrl(menu.bannerUrl)} alt={menu.ad} style={{ display: 'block', width: '100%', height: 'auto' }} />
          )}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.15) 100%)'
          }} />
        </div>

        {/* Google yorum butonu — banner'ın İÇİNDE değil, bitişinin hemen altında (beyaz alanda) durur;
            banner görseline karışıp kaybolmasın diye normal akışta, sağa yaslı ayrı bir satır. */}
        {menu.googleYorumLink && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '6px 16px 0' }}>
            <a
              href={menu.googleYorumLink}
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#fff', fontSize: 12, fontWeight: 700,
                background: tema.accent, padding: '7px 14px', borderRadius: 20, textDecoration: 'none',
                display: 'flex', alignItems: 'center', gap: 6, boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
              }}
            >
              ⭐ Google Yorumu Yaz
            </a>
          </div>
        )}

        {/* Logo + işletme adı — banner'ın ALTINDA, beyaz alanda (banner metniyle çakışmasın diye) */}
        <div style={{ textAlign: 'center', padding: menu.logoUrl ? '0 16px 14px' : '16px 16px 14px' }}>
          {menu.logoUrl && (
            <img
              src={dosyaUrl(menu.logoUrl)}
              alt={menu.ad}
              style={{
                width: 76, height: 76, borderRadius: '50%', objectFit: 'cover',
                border: `4px solid ${tema.kartUst}`, boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
                marginTop: -38, background: '#fff',
                position: 'relative', zIndex: 2
              }}
            />
          )}
          <h1 style={{ margin: '8px 0 0', fontSize: 22, fontWeight: 800, color: tema.koyu }}>{menu.ad}</h1>
          {masaNo && (
            <div style={{
              display: 'inline-block', marginTop: 6, padding: '3px 12px', borderRadius: 20,
              background: tema.koyu, color: '#fff', fontSize: 12, fontWeight: 700
            }}>
              Masa {masaNo}
            </div>
          )}
        </div>

        {/* Garson Çağır / Hesap İste — sipariş değil, sadece garsona giden bir bilgi notu.
            Müdür panelinden Pasif yapılan fonksiyonlar burada hiç görünmez. */}
        {(menu.garsonCagirAyar !== 'PASIF' || menu.hesapIsteAyar !== 'PASIF') && (
          <div style={{ display: 'flex', gap: 10, padding: '0 16px 16px' }}>
            {menu.garsonCagirAyar !== 'PASIF' && (
              <button
                onClick={() => setBildirimOnayPopup('GARSON_CAGIR')}
                disabled={bildirimGonderiliyor === 'GARSON_CAGIR'}
                style={{
                  flex: 1, padding: '10px 8px', borderRadius: 10, border: '1px solid #e0e0e0', cursor: 'pointer',
                  background: '#fff', color: tema.koyu, fontSize: 13, fontWeight: 700
                }}
              >
                🔔 {bildirimGonderiliyor === 'GARSON_CAGIR' ? 'Gönderiliyor...' : 'Garson Çağır'}
              </button>
            )}
            {menu.hesapIsteAyar !== 'PASIF' && (
              <button
                onClick={() => setBildirimOnayPopup('HESAP_ISTE')}
                disabled={bildirimGonderiliyor === 'HESAP_ISTE'}
                style={{
                  flex: 1, padding: '10px 8px', borderRadius: 10, border: '1px solid #e0e0e0', cursor: 'pointer',
                  background: '#fff', color: tema.koyu, fontSize: 13, fontWeight: 700
                }}
              >
                🧾 {bildirimGonderiliyor === 'HESAP_ISTE' ? 'Gönderiliyor...' : 'Hesap İste'}
              </button>
            )}
          </div>
        )}
        {bildirimMesaj && (
          <div style={{
            margin: '0 16px 16px', padding: '8px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600, textAlign: 'center',
            background: bildirimMesaj.tip === 'basari' ? '#e6f4ea' : '#fdecea',
            color: bildirimMesaj.tip === 'basari' ? '#1e5c30' : '#8b1a1a'
          }}>
            {bildirimMesaj.metin}
          </div>
        )}
        {bildirimMesaj?.tip === 'hata' && <WifiYonlendirme tema={tema} ssid={menu.wifiSsid} sifre={menu.wifiSifre} />}

        {/* Siparişlerim — müşteri kendi siparişinin güncel durumunu görür, henüz hazırlanmaya
            başlamadıysa (BEKLIYOR) iptal edebilir. Periyodik olarak kendini yeniler. */}
        {masaSiparisleri.length > 0 && (
          <div style={{ padding: '0 16px 16px' }}>
            <h3 style={{ color: tema.koyu, fontSize: 15, margin: '0 0 8px' }}>Siparişlerim</h3>
            {masaSiparisleri.map((g) => {
              const durumEtiket = {
                BEKLIYOR: { metin: 'Bekliyor', bg: '#e8f0fe', renk: '#1e4a8b' },
                HAZIRLANIYOR: { metin: 'Hazırlanıyor', bg: '#fff3e0', renk: '#8b5a1a' },
                TESLIM_EDILDI: { metin: 'Teslim Edildi', bg: '#e6f4ea', renk: '#1e5c30' },
                IPTAL: { metin: 'İptal Edildi', bg: '#fdecea', renk: '#8b1a1a' }
              }[g.durum] || { metin: g.durum, bg: '#eee', renk: '#333' };

              return (
                <div key={g.id} style={{ background: '#fff', borderRadius: 10, padding: 12, marginBottom: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 10px', borderRadius: 10, background: durumEtiket.bg, color: durumEtiket.renk }}>
                      {durumEtiket.metin}
                    </span>
                    {g.iptalEdilebilir && (
                      <button
                        onClick={() => { setIptalHata(''); setIptalPopup(g); }}
                        style={{ fontSize: 12, fontWeight: 700, color: '#8b1a1a', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
                      >
                        İptal Et
                      </button>
                    )}
                  </div>
                  {g.urunler.map((k, i) => (
                    <div key={i} style={{ fontSize: 13, color: '#374151' }}>{k.adet} x {k.urunAdi}</div>
                  ))}
                  <div style={{ fontWeight: 700, fontSize: 13, marginTop: 4, color: tema.accent }}>Toplam: {paraFormatla(g.toplam)} ₺</div>
                </div>
              );
            })}
          </div>
        )}

        {menu.gruplar.length === 0 && (
        <div style={{ padding: 30, textAlign: 'center', color: '#6b7684' }}>Menü henüz hazırlanıyor.</div>
      )}

      {/* Kategori sekmeleri — yana kaydırma yok, sığmayanlar alt satıra geçer */}
      {menu.gruplar.length > 1 && (
        <div style={{
          display: 'flex', flexWrap: 'wrap', gap: 8, padding: '0 16px 16px', position: 'sticky', top: 0,
          background: tema.kartUst, zIndex: 10
        }}>
          {menu.gruplar.map((grup) => (
            <button
              key={grup.id}
              onClick={() => setAktifGrup(grup.id)}
              style={{
                whiteSpace: 'nowrap', padding: '8px 16px', borderRadius: 20, border: 'none', cursor: 'pointer',
                fontSize: 13, fontWeight: 700,
                background: aktifGrup === grup.id ? tema.accent : '#fff',
                color: aktifGrup === grup.id ? '#fff' : tema.koyu,
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
              }}
            >
              {grup.ad}
            </button>
          ))}
        </div>
      )}

      {menu.gruplar.filter((grup) => grup.id === aktifGrup).map((grup) => (
        <div key={grup.id} id={`grup-${grup.id}`} style={{ padding: '4px 16px 20px' }}>
          <h3 style={{ color: tema.koyu, fontSize: 18, borderLeft: `4px solid ${tema.accent}`, paddingLeft: 10, margin: '10px 0 12px' }}>
            {grup.ad}
          </h3>
          {grup.urunler.map((urun) => {
            const sepetteki = sepet.find((k) => k.urunId === urun.id);
            return (
              <div key={urun.id} style={{
                display: 'flex', gap: 12, padding: 12, marginBottom: 10, background: '#fff',
                borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
              }}>
                {urun.gorselUrl ? (
                  <img src={dosyaUrl(urun.gorselUrl)} alt={urun.ad} style={{ width: 68, height: 68, borderRadius: 10, objectFit: 'cover', flexShrink: 0 }} />
                ) : (
                  <div style={{ width: 68, height: 68, borderRadius: 10, background: '#f0f0f0', flexShrink: 0 }} />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontWeight: 700, color: tema.koyu }}>
                    <span>{urun.ad}</span>
                    <span style={{ color: tema.accent, whiteSpace: 'nowrap' }}>{paraFormatla(urun.fiyat)} ₺</span>
                  </div>
                  {urun.aciklama && <div style={{ fontSize: 13, color: '#6b7684', marginTop: 4 }}>{urun.aciklama}</div>}

                  {menu.siparisAyar !== 'PASIF' && (
                    sepetteki ? (
                      <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <button onClick={() => adetDegistir(urun.id, -1)} style={btnAdetStil}>−</button>
                        <span style={{ fontWeight: 700, minWidth: 16, textAlign: 'center' }}>{sepetteki.adet}</span>
                        <button onClick={() => adetDegistir(urun.id, 1)} style={btnAdetStil}>+</button>
                      </div>
                    ) : (
                      <button
                        onClick={() => sepeteEkle(urun)}
                        style={{
                          marginTop: 8, padding: '6px 14px', borderRadius: 6, border: 'none', cursor: 'pointer',
                          background: tema.accent, color: '#fff', fontSize: 12, fontWeight: 700
                        }}
                      >
                        Sepete Ekle
                      </button>
                    )
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ))}

        {footerIcerigi}

        <div style={{ textAlign: 'center', fontSize: 11, color: '#aab0b8', padding: '10px 0' }}>MenuPaylas ile hazırlanmıştır</div>

        {/* Sepet ikonu (sabit, alt sağ köşe) */}
        {toplamAdet > 0 && !sepetAcik && (
          <button
            onClick={() => setSepetAcik(true)}
            style={{
              position: 'fixed', bottom: 20, right: 'calc(50vw - 240px + 20px)', maxWidth: 480,
              background: tema.koyu, color: '#fff', border: 'none', borderRadius: 30,
              padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 8,
              boxShadow: '0 4px 14px rgba(0,0,0,0.3)', cursor: 'pointer', fontWeight: 700, zIndex: 100
            }}
          >
            🛒 Sepet ({toplamAdet}) — {paraFormatla(toplam)} ₺
          </button>
        )}

        {/* Sepet paneli */}
        {sepetAcik && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex',
            alignItems: 'flex-end', justifyContent: 'center', zIndex: 200
          }}>
            <div style={{
              width: '100%', maxWidth: 480, background: '#fff', borderRadius: '18px 18px 0 0',
              padding: 20, maxHeight: '85vh', overflowY: 'auto'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <h3 style={{ margin: 0, color: tema.koyu }}>Sepetim</h3>
                <button onClick={() => setSepetAcik(false)} className="btn btn-koyu" style={{ padding: '5px 12px' }}>✕</button>
              </div>

              {onaySonuc && (
                <div style={{
                  marginBottom: 12, padding: 10, borderRadius: 8, fontSize: 13, fontWeight: 600,
                  background: onaySonuc.tip === 'basari' ? '#e6f4ea' : '#fdecea',
                  color: onaySonuc.tip === 'basari' ? '#1e5c30' : '#8b1a1a'
                }}>
                  {onaySonuc.tip === 'basari' ? '✓ ' : '✕ '}{onaySonuc.metin}
                </div>
              )}
              {onaySonuc?.tip === 'hata' && <WifiYonlendirme tema={tema} ssid={menu.wifiSsid} sifre={menu.wifiSifre} />}

              {sepet.length === 0 ? (
                <div style={{ color: '#6b7684', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>Sepetiniz boş.</div>
              ) : (
                <>
                  {sepet.map((k) => (
                    <div key={k.urunId} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, color: tema.koyu }}>{k.ad}</div>
                        <div style={{ fontSize: 12, color: '#6b7684' }}>{paraFormatla(k.fiyat)} ₺ x {k.adet} = {paraFormatla(k.fiyat * k.adet)} ₺</div>
                      </div>
                      <button onClick={() => adetDegistir(k.urunId, -1)} style={btnAdetStil}>−</button>
                      <span style={{ fontWeight: 700, minWidth: 14, textAlign: 'center' }}>{k.adet}</span>
                      <button onClick={() => adetDegistir(k.urunId, 1)} style={btnAdetStil}>+</button>
                      <button onClick={() => sepettenCikar(k.urunId)} style={{ ...btnAdetStil, color: '#8b1a1a', border: '1px solid #8b1a1a' }}>🗑</button>
                    </div>
                  ))}

                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: 16, color: tema.koyu, margin: '14px 0' }}>
                    <span>Toplam</span>
                    <span>{paraFormatla(toplam)} ₺</span>
                  </div>

                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Not / Özel İstek (opsiyonel)</label>
                  <textarea
                    value={aciklama}
                    onChange={(e) => setAciklama(e.target.value)}
                    placeholder="Örn: acısız olsun, çatal-bıçak eklensin..."
                    rows={2}
                    style={{ width: '100%', boxSizing: 'border-box', padding: 10, borderRadius: 8, border: '1px solid #ddd', marginBottom: 14, fontFamily: 'inherit', fontSize: 13 }}
                  />

                  <button
                    onClick={siparisiOnayla}
                    disabled={gonderiliyor}
                    style={{ width: '100%', padding: 14, fontSize: 15, fontWeight: 700, border: 'none', borderRadius: 8, cursor: 'pointer', background: tema.accent, color: '#fff' }}
                  >
                    {gonderiliyor ? 'Gönderiliyor...' : 'Siparişi Onayla'}
                  </button>
                </>
              )}
            </div>
          </div>
        )}

        {bildirimOnayPopup && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', zIndex: 300
          }}>
            <div style={{ background: '#fff', borderRadius: 14, padding: 22, width: '85%', maxWidth: 320, textAlign: 'center' }}>
              <h3 style={{ margin: '0 0 20px', color: tema.koyu }}>
                {bildirimOnayPopup === 'GARSON_CAGIR' ? 'Garson Çağırıyorum' : 'Hesap İstiyorum'}
              </h3>
              <div style={{ display: 'flex', gap: 10 }}>
                <button
                  onClick={() => setBildirimOnayPopup(null)}
                  style={{ flex: 1, padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: '#eee', color: '#333', fontWeight: 700 }}
                >
                  Vazgeç
                </button>
                <button
                  onClick={() => bildirimGonderTikla(bildirimOnayPopup)}
                  disabled={!!bildirimGonderiliyor}
                  style={{ flex: 1, padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: tema.accent, color: '#fff', fontWeight: 700 }}
                >
                  Onayla
                </button>
              </div>
            </div>
          </div>
        )}

        {iptalPopup && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', zIndex: 300
          }}>
            <div style={{ background: '#fff', borderRadius: 14, padding: 22, width: '85%', maxWidth: 320, textAlign: 'center' }}>
              <h3 style={{ margin: '0 0 12px', color: tema.koyu }}>Siparişi İptal Et</h3>
              {iptalHata && (
                <div style={{ marginBottom: 12, padding: 10, borderRadius: 8, fontSize: 13, fontWeight: 600, background: '#fdecea', color: '#8b1a1a' }}>
                  {iptalHata}
                </div>
              )}
              <div style={{ display: 'flex', gap: 10 }}>
                <button
                  onClick={() => setIptalPopup(null)}
                  style={{ flex: 1, padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: '#eee', color: '#333', fontWeight: 700 }}
                >
                  Vazgeç
                </button>
                <button
                  onClick={siparisiIptalEt}
                  style={{ flex: 1, padding: 12, borderRadius: 8, border: 'none', cursor: 'pointer', background: '#8b1a1a', color: '#fff', fontWeight: 700 }}
                >
                  Onayla
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const btnAdetStil = {
  width: 26, height: 26, borderRadius: '50%', border: '1px solid #ddd', background: '#fff',
  cursor: 'pointer', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0
};

// Cafe WiFi'sine bağlı olmayan bir müşteri sipariş/bildirim denediğinde 403 hatası alır — bu bileşen
// işletmenin panelden tanımladığı SSID/şifreyi gösterip bağlanmayı kolaylaştırır. Tarayıcılar web
// sayfasından doğrudan bir WiFi ağına bağlanmayı desteklemez (OS güvenlik kısıtlaması). Android'de
// sistem ayarlarına atlatan "intent://" linki denendi ama Chrome artık paketsiz/system-settings
// intent'lerini spam önleme amacıyla engelliyor — çalışmıyor, bu yüzden kaldırıldı. Elde kalan tek
// güvenilir yol: şifreyi kopyalatıp kullanıcıyı Ayarlar'a manuel yönlendirmek.
function WifiYonlendirme({ tema, ssid, sifre }) {
  const [kopyalandi, setKopyalandi] = useState(false);
  const [kopyalamaHatasi, setKopyalamaHatasi] = useState(false);
  if (!ssid) return null;

  const sifreyiKopyala = () => {
    setKopyalamaHatasi(false);
    navigator.clipboard?.writeText(sifre || '')
      .then(() => {
        setKopyalandi(true);
        setTimeout(() => setKopyalandi(false), 2000);
      })
      .catch(() => setKopyalamaHatasi(true));
  };

  return (
    <div style={{ marginTop: 8, marginBottom: 12, padding: 12, borderRadius: 10, background: '#fff', border: `1px solid ${tema.accent}` }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: tema.koyu, marginBottom: 6 }}>📶 Cafe WiFi'sine Bağlanın</div>
      <div style={{ fontSize: 13, color: '#374151' }}>Ağ Adı: <strong>{ssid}</strong></div>
      {sifre && <div style={{ fontSize: 13, color: '#374151', marginBottom: 8 }}>Şifre: <strong>{sifre}</strong></div>}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {sifre && (
          <button
            onClick={sifreyiKopyala}
            style={{ padding: '7px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', background: tema.accent, color: '#fff', fontSize: 12, fontWeight: 700 }}
          >
            {kopyalandi ? '✓ Kopyalandı' : 'Şifreyi Kopyala'}
          </button>
        )}
        {kopyalamaHatasi && (
          <div style={{ width: '100%', fontSize: 11, color: '#8b1a1a' }}>
            Otomatik kopyalanamadı, yukarıdaki şifreyi elle seçip kopyalayabilirsiniz.
          </div>
        )}
      </div>
      <div style={{ fontSize: 11, color: '#6b7684', marginTop: 8 }}>
        Şifreyi kopyaladıktan sonra telefonunuzun Ayarlar &gt; WiFi bölümüne gidip yukarıdaki ağa dokunun ve kopyaladığınız şifreyi yapıştırın.
      </div>
    </div>
  );
}
